<template>
  <div class="stripe-form-container">
    <!-- <div ref="card"></div> -->
    <b-row class="" v-if="card_error"><b-col>
        <!-- <div id="card-error" class="my-3">
            <p class="error_validation_message_p_dy">{{ card_error }}</p>
          </div> -->
        <b-alert variant="danger" :class="{
          'alert-danger-dy': client_name == 'DY',
          'alert-danger-doorder': client_name == 'Doorder',
          'alert-danger-doorder': client_name == 'GARDENHELP',
        }" :show="card_error != null">{{ card_error }}
        </b-alert>
      </b-col></b-row>
    <!-- <b-row class="my-3">
        <b-col md="12">
          <b-form-group id="card-name-input-group" class="pb-0">
            <b-form-input
              class="form-control-auth"
              v-bind:class="{
                'form-control-auth-mid': client_name == 'MID',
                'form-control-auth-doom-yoga': client_name == 'DY',
                'form-control-doorder': client_name == 'Doorder',
              }"
              id="card_name_holder"
              v-model="card_name_holder"
              type="text"
              placeholder="Card Name Holder"
              required
            ></b-form-input> </b-form-group></b-col
      ></b-row> -->
    <!-- <label>Card Number</label> -->

    <b-row v-if="require_card == 'true' || this.require_card == true">
      <b-col sm="6" class="mb-1">
        <b-form-group :class="form_group_class" label="Card number" :label-class="display_label ? '' : 'd-none'">
          <div id="card-number"></div>
        </b-form-group>
      </b-col>
      <b-col sm="6" class="mb-1">
        <b-form-group :class="form_group_class" label="Expiry date" :label-class="display_label ? '' : 'd-none'">
          <div id="card-expiry"></div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="require_card == 'true' || this.require_card == true">
      <b-col sm="6" class="mb-3">
        <b-form-group :class="form_group_class" label="CVC" :label-class="display_label ? '' : 'd-none'">
          <div id="card-cvc"></div>
        </b-form-group>
        <input type="hidden" v-model="stripe_token" />
      </b-col>
      <b-col sm="6" class="mb-3">
        <img v-if="client_name == 'DY'" src="@/assets/images/logo-stripe-light.png"
          class="d-block stripeLogo payment-logo-doomyoga" />
        <img v-if="client_name == 'Doorder'" src="@/assets/images/secure-stripe-payment-logo.png"
          class="d-block stripeLogo payment-logo-doorder" />
        <img v-if="display_img == true" src="@/assets/images/stripe-logo.png" class="d-block stripeLogo" />

      </b-col>
    </b-row>
    <b-row v-if="display_submit_button == true" class="justify-content-center justify-content-lg-right mt-3 mx-0">
      <b-col xl="3" lg="4" sm="4" class=" text-center px-0">
        <b-button v-if="!is_loading_payment" type="button" :variant="variant_primary" class="btn-bumblebee  mb-1 w-100"
          :class="button_submit_class" @click="purchase" id="addCardButton">Add Card</b-button>
        <b-button v-else type="button" disabled :variant="variant_primary" class="btn-bumblebee  mb-1 w-100"
          :class="button_submit_class">
          <b-spinner small label="Small Spinner" variant="light"></b-spinner>
          Loading
        </b-button>

      </b-col>
    </b-row>
  </div>
</template>
  
  <!-- <script src="https://js.stripe.com/v3/"></script> -->
  
<script>
// let stripe = Stripe(
//     "pk_test_xKo82JXCYteO2H5AXYX67M3r001RG26ZN6"
//   ),
//   stripeElements = stripe.elements(),
// card = undefined;

// let options = {
// hidePostalCode: true,
// placeholder: "Card number",
// classes: elementClasses,

// };

import axios from "axios";
import $ from "jquery";

export default {
  name: "StripeComponentUser",
  props: [
    "client_name",
    "require_card",
    "element_class_base",
    "display_label",
    "form_group_class",

    "display_img",
    "model_type", "model_id",
    "variant_primary", "button_submit_class", "alert_btn_class",
    "future_use_card", "payment_method_id", "display_submit_button"
  ],
  data() {
    return {
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      card_name_holder: null,
      card_error: null,
      stripe_token: null,
      elementClasses: {
        base: "",
        focus: "focus",
        empty: "empty",
        invalid: "invalid",
      },
      style: {
        base: {
          color: "#6e6b7b",
          "::placeholder": {
            color: "#aaa",
          },
          fontWeight: "400",
          fontFamily: "Montserrat, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          lineHeight: "22px",
          // backgroundColor: "#393939",
          // color: "#fff",
          // "border-radius": "8px",
          // 'padding': "12px",

          // iconColor: "#c4f0ff",
          // fontWeight: "500",
          // fontFamily: "Futura LT",
          // fontSize: "16px",
          // fontSmoothing: "antialiased",
          // ":-webkit-autofill": {
          //   color: "#fce883",
          // },
        },

        invalid: {
          // All of the error styles go inside of here.
          // color: "#00ff00",
        },
      },
      stripe: null,
      stripeElements: null,
      is_loading_payment: false,
      stripe_customer_id: null,
      stripe_payment_method: null,
      card_last4: null,
    };
  },
  mounted() {
    this.stripe = Stripe(
      "pk_test_xKo82JXCYteO2H5AXYX67M3r001RG26ZN6"
    );
    this.stripeElements = this.stripe.elements();

    this.elementClasses.base = this.element_class_base;

    if (this.client_name == 'DY') {
      this.style.base.color = '#fff'
    }

    // console.log(options);
    // card = elements.create("card", options);
    // card.mount(this.$refs.card);
    console.log("in stripe components mounted ", this.require_card);
    if (this.require_card == "true" || this.require_card == true) {
      this.initCardForm();
    } else {
      if (this.cardNumber != null) {
        this.cardNumber.destroy();
        this.cardExpiry.destroy();
        this.cardCvc.destroy();
      }
    }
  },
  updated() {
    // this.stripe = Stripe(
    //   "pk_test_xKo82JXCYteO2H5AXYX67M3r001RG26ZN6"
    // );
    // this.stripeElements = this.stripe.elements();

    // console.log("in stripe components updated ", this.require_card);
    // console.log(this.stripe_token);
    // if (this.require_card == "true" || this.require_card == true) {
    //   this.initCardForm();
    // } else {
    //   if (this.cardNumber != null) {
    //     this.cardNumber.destroy();
    //     this.cardExpiry.destroy();
    //     this.cardCvc.destroy();
    //   }
    // }
  },

  computed: {
    _payment_method_id: {
      get() {
        return this.payment_method_id;
      },
      set(value) {
        this.$emit("update:payment_method_id", value);
      },
    },
  },
  methods: {
    initCardForm() {
      this.cardNumber = this.stripeElements.create("cardNumber", {
        classes: this.elementClasses,
        style: this.style,
        placeholder: "Card number",
      });
      this.cardNumber.mount("#card-number");
      // options.placeholder = "MM / YY";
      this.cardExpiry = this.stripeElements.create("cardExpiry", {
        classes: this.elementClasses,
        style: this.style,
      });
      this.cardExpiry.mount("#card-expiry");
      // options.placeholder = "CVC";
      this.cardCvc = this.stripeElements.create("cardCvc", {
        classes: this.elementClasses,
        style: this.style,
      });
      this.cardCvc.mount("#card-cvc");
    },
    async purchase() {
      console.log("purchase ", this.cardNumber);

      this.is_loading_payment = true
      let temp = this, success_purchase=false;
      await this.stripe.createToken(this.cardNumber).then(async function (result) {
        // Access the token with result.token
        console.log(result);
        if (result.error != null) {
          // handle error here
          console.log(result.error);
          temp.card_error = result.error.message;
          temp.is_loading_payment = false
          success_purchase =  false;
        } else {
          temp.card_error = null;
          temp.stripe_token = result.token.id;
          temp.card_last4 = result.token.card.last4
          console.log(result.token.id);
          console.log(temp.stripe_token, temp.card_last4);
          await temp.createStripeCustomerRequest()
          // temp.$emit("update:stripe_token", result.token.id);
          // temp.$emit("stripe_token")
          // return temp.stripe_token
          // temp.submitPaymentForm();
          // return result.token.id
          success_purchase= true
        }
      });
      return success_purchase
    },

    async createStripeCustomerRequest() {
      console.log("in create customer request")
      let user = JSON.parse(window.localStorage.getItem("user"));
      let name = user.name, email = user.email
      let requestData = {
        "name": name,
        "email": email,
        "stripe_token": this.stripe_token
      }
      console.log(requestData)
      await axios
        .post("payment/stripe/customer/create", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: 'BUMBLEBEE',//this.client_name,,            
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then(async (response) => {
          console.log(response);
          if (response.data.error == 1) {
            this.$fire({
              // title: "Title",
              text: response.data.message,
              type: "error",
              customClass: {
                confirmButton: "btn  " + temp.alert_btn_class
              },
              // timer: 3000,
            }).then((r) => {
              // console.log(r.value);
            });
            //   this.$swal({
            //     icon: "error",
            //     text: response.data.message,
            //     confirmButtonColor: '#03989E',
            //     customClass: {
            //       confirmButton: "btn btn-primary rounded-pill "
            //     },
            //     // timer: 3000,
            //   }).then((r) => {
            //     // console.log(r.value);
            //   });
          } else if (response.data.error == 0) {
            console.log(response.data)
            this.stripe_customer_id = response.data.customer_id
            this.stripe_payment_method = response.data.payment_method_id
            console.log("-->", this.stripe_customer_id, this.stripe_payment_method)
            await this.addPaymentMethodRequest()
          }

        })
        .catch((error) => {
          console.log(error);
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              confirmButton: "btn  " + temp.alert_btn_class
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading_payment = false
          });
        });
    },
    async addPaymentMethodRequest() {
      console.log("in add payment method request")
      let user = JSON.parse(window.localStorage.getItem("user"));
      let name = user.name, email = user.email, user_id = user.id
      let requestData = {
        "name": name,
        "model_type": "User",
        "model_id": user_id,
        "account_id": this.stripe_customer_id,
        "last_four": this.card_last4,
        "one_time": this.future_use_card,
        "payment_method_id":this.stripe_payment_method
      }
      console.log(requestData)
      await axios
        .post("payment/pm/create", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this._payment_method_id = response.data.id
          this.is_loading_payment = false
          // if (response.data.error == 1) {
          //   this.$fire({
          //     // title: "Title",
          //     text: response.data.message,
          //     type: "error",
          //     customClass: {
          //       confirmButton: "btn  " + temp.alert_btn_class
          //     },
          //     // timer: 3000,
          //   }).then((r) => {
          //     // console.log(r.value);
          //   });
          //   //   this.$swal({
          //   //     icon: "error",
          //   //     text: response.data.message,
          //   //     confirmButtonColor: '#03989E',
          //   //     customClass: {
          //   //       confirmButton: "btn btn-primary rounded-pill "
          //   //     },
          //   //     // timer: 3000,
          //   //   }).then((r) => {
          //   //     // console.log(r.value);
          //   //   });
          // } else if (response.data.error == 0) {
          //   console.log(response.data)
          //   this.stripe_customer_id = response.data.customer_id
          //   console.log(this.stripe_customer_id)
          // }

        })
        .catch((error) => {
          console.log(error);
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              confirmButton: "btn  " + temp.alert_btn_class
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading_payment = false
          });
        });
    },
    beforeDestroy() {
      // card.destroy(this.$refs.card);
      // console.log(this.cardNumber)
      // console.log(this.cardExpiry)
      // console.log(this.cardCvc)
      if (this.cardNumber != null) {
        this.cardNumber.destroy();
        this.cardExpiry.destroy();
        this.cardCvc.destroy();
      }
    },
  }
};
</script>
  


// WEBPACK FOOTER //
// src/components/Payment/StripeComponentUser.vue